import { Tabs } from "@mantine/core";
import React from "react";
import { FaFilter, FaSearch } from "react-icons/fa";

const traders = [
  {
    name: "cross-sectional-relative-...",
    pnl: "+107,775.86",
    roi: "+34.66%",
    aum: "880,732.89",
    mdd: "2.61%",
    sharpe: "2.94",
    isFull: true,
  },
  {
    name: "Crypto Lama",
    pnl: "+101,366.41",
    roi: "+25.15%",
    aum: "1,836,919.28",
    mdd: "15.47%",
    sharpe: "1.50",
    isFull: true,
  },
  {
    name: "JaBBBi",
    pnl: "+66,003.16",
    roi: "+25.02%",
    aum: "816,736.00",
    mdd: "17.60%",
    sharpe: "1.37",
    isFull: true,
  },
];

const Spot = () => {
  return (
    <div className="p-6 space-y-6">
      <div className="bg-yellow-100 p-4 flex justify-between items-center rounded">
        <span className="text-sm font-medium text-black">
          Join the Launch: Be a Pioneer Spot Lead Trader!
        </span>
        <button className="bg-yellow-300 px-4 py-1 rounded hover:bg-yellow-400">
          Apply Now
        </button>
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-6">
        <div>
          <h1 className="text-3xl font-bold">Spot Copy Trading</h1>
          <p className="text-gray-600 mt-1">
            Follow the world's top crypto traders and copy their trades with one
            click
          </p>
          <div className="mt-2 text-yellow-600 text-sm flex items-center gap-1">
            📢 Tillionx Spot Copy Trading Launches Elite Trader Program for Lead
            Traders
          </div>
        </div>
        <div className="border rounded p-4 flex flex-col justify-center items-center text-center max-w-sm">
          <p className="font-semibold text-lg">
            Join Elite Trader Program, Up To 30% Profit Share!
          </p>
          <div className="mt-2 text-yellow-500">👤📊</div>
        </div>
      </div>

      <Tabs defaultValue="Public Portfolios">
        <Tabs.List>
          <Tabs.Tab value="Public Portfolios">Public Portfolios</Tabs.Tab>
          <Tabs.Tab value="Private Portfolios">Private Portfolios</Tabs.Tab>
          <Tabs.Tab value="My Favorites">My Favorites</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="Public Portfolios">
          <div className="flex justify-between my-6">
            <div className="flex items-center gap-2">
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>30 Days</option>
                <option>60 Days</option>
                <option>90 Days</option>
              </select>
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>PnL</option>
                <option>PnL</option>
                <option>PnL</option>
              </select>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center border rounded-lg px-3 py-2 w-60">
                <FaSearch className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Trader's Name"
                  className="outline-none text-sm w-full bg-transparent"
                />
              </div>

              <button className="p-2 rounded-md">
                <FaFilter className="" />
              </button>

              <button className="bg-gray-800 text-white text-xs font-semibold px-2 py-1 rounded">
                VS
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {traders.map((trader, idx) => (
              <div
                key={idx}
                className="border rounded-lg p-4 space-y-3 hover:shadow-md transition"
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2 font-semibold">
                    <span className="w-8 h-8 bg-gray-200 rounded-full" />
                    {trader.name}
                  </div>
                  <span className="text-xs text-gray-400">⭐</span>
                </div>

                <div>
                  <p className="text-xs text-gray-500">30 Days PNL</p>
                  <p className="text-green-500 text-xl font-bold">
                    {trader.pnl}
                  </p>
                  <p className="text-xs text-green-400">ROI {trader.roi}</p>
                </div>

                <div className="grid grid-cols-3 gap-2 text-xs text-gray-500">
                  <div>
                    <p>AUM</p>
                    <p className="font-medium">{trader.aum}</p>
                  </div>
                  <div>
                    <p>30 Days MDD</p>
                    <p className="font-medium">{trader.mdd}</p>
                  </div>
                  <div>
                    <p>Sharpe Ratio</p>
                    <p className="font-medium">{trader.sharpe}</p>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button className="w-1/2 bg-gray-200 py-1 rounded text-sm">
                    Mock
                  </button>
                  <button
                    className={`w-1/2 py-1 rounded text-sm font-medium ${
                      trader.isFull
                        ? "bg-red-100 text-red-600 cursor-not-allowed"
                        : "bg-yellow-300 hover:bg-yellow-400 text-black"
                    }`}
                  >
                    {trader.isFull ? "Full" : "Copy"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Tabs.Panel>
        <Tabs.Panel value="Private Portfolios">
         <div className="flex justify-between my-6">
            <div className="flex items-center gap-2">
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>30 Days</option>
                <option>60 Days</option>
                <option>90 Days</option>
              </select>
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>PnL</option>
                <option>PnL</option>
                <option>PnL</option>
              </select>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center border rounded-lg px-3 py-2 w-60">
                <FaSearch className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Trader's Name"
                  className="outline-none text-sm w-full bg-transparent"
                />
              </div>

              <button className="p-2 rounded-md">
                <FaFilter className="" />
              </button>

              <button className="bg-gray-800 text-white text-xs font-semibold px-2 py-1 rounded">
                VS
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {traders.map((trader, idx) => (
              <div
                key={idx}
                className="border rounded-lg p-4 space-y-3 hover:shadow-md transition"
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2 font-semibold">
                    <span className="w-8 h-8 bg-gray-200 rounded-full" />
                    {trader.name}
                  </div>
                  <span className="text-xs text-gray-400">⭐</span>
                </div>

                <div>
                  <p className="text-xs text-gray-500">30 Days PNL</p>
                  <p className="text-green-500 text-xl font-bold">
                    {trader.pnl}
                  </p>
                  <p className="text-xs text-green-400">ROI {trader.roi}</p>
                </div>

                <div className="grid grid-cols-3 gap-2 text-xs text-gray-500">
                  <div>
                    <p>AUM</p>
                    <p className="font-medium">{trader.aum}</p>
                  </div>
                  <div>
                    <p>30 Days MDD</p>
                    <p className="font-medium">{trader.mdd}</p>
                  </div>
                  <div>
                    <p>Sharpe Ratio</p>
                    <p className="font-medium">{trader.sharpe}</p>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button className="w-1/2 bg-gray-200 py-1 rounded text-sm">
                    Mock
                  </button>
                  <button
                    className={`w-1/2 py-1 rounded text-sm font-medium ${
                      trader.isFull
                        ? "bg-red-100 text-red-600 cursor-not-allowed"
                        : "bg-yellow-300 hover:bg-yellow-400 text-black"
                    }`}
                  >
                    {trader.isFull ? "Full" : "Copy"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Tabs.Panel>
        <Tabs.Panel value="My Favorites">
          <div className="flex justify-between my-6">
            <div className="flex items-center gap-2">
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>30 Days</option>
                <option>60 Days</option>
                <option>90 Days</option>
              </select>
              <select className="border text-sm px-2 py-1 rounded bg-transparent">
                <option>PnL</option>
                <option>PnL</option>
                <option>PnL</option>
              </select>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center border rounded-lg px-3 py-2 w-60">
                <FaSearch className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Trader's Name"
                  className="outline-none text-sm w-full bg-transparent"
                />
              </div>

              <button className="p-2 rounded-md">
                <FaFilter className="" />
              </button>

              <button className="bg-gray-800 text-white text-xs font-semibold px-2 py-1 rounded">
                VS
              </button>
            </div>
          </div>
          <div className="w-full flex justify-center items-center py-16">
            <h3>No portfolios found</h3>
          </div>
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default Spot;
